module.exports = __webpack_public_path__ + "img/homevisit_02.abbe6b20.svg";